import { Component, OnInit } from '@angular/core';

import {
  ClosableModalWithErrorResponseModel
} from '../../../../../shared/components/base/closable-modal-with-error-response-model';
import { NotificationService, PbasService } from '../../../../../shared/services';
import { ModalService } from '../../../../../shared/modules/modal';
import {
  CharacterizeTestedPartyModalPayload,
  CharacterizationFunctionPerformed,
  CharacterizeTestedPartyFunctionsPerformed,
  CharacterizeTestedPartyFunctionsPerformedErrorResponse
} from '../../../../../shared/models';

@Component({
  selector: 'provide-features-modal',
  templateUrl: './provide-features-modal.component.html',
})
export class ProvideFeaturesModalComponent
  extends ClosableModalWithErrorResponseModel<CharacterizeTestedPartyFunctionsPerformedErrorResponse>
  implements OnInit {

  data: CharacterizeTestedPartyModalPayload;
  functionsPerformed = [];
  functionsPerformedRequest = new CharacterizeTestedPartyFunctionsPerformed();
  isCheckboxValueChanged = false;

  constructor(
    protected modalService: ModalService,
    protected notificationService: NotificationService,
    private _pbasService: PbasService
  ) {
    super(notificationService, modalService);
  }

  ngOnInit() {
    this.listenForErrorMessages();
    this.functionsPerformed = JSON.parse(JSON.stringify(this.data.characterization.characterizationFunctionsPerformed));
    this.groupFunctionsPerformed();
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this.prepareFunctionsPerformedForRequest();
    if (this.data.characterization.characterizationId) {
      this.updateFeatures();
      return;
    }
    this.createFeatures();
  }

  handleCheckboxChange(functionPerformed: CharacterizationFunctionPerformed): void {
    functionPerformed.state = !functionPerformed.state;
    this.isCheckboxValueChanged = true;
  }

  private createFeatures(): void {
    this._pbasService
      .saveTestedPartyCharacterizationFeatures(
        this.data.testedParty.pba.pbaId,
        this.functionsPerformedRequest)
      .subscribe(() => {
        this.success();
        this.close();
      }
      );
  }

  private updateFeatures(): void {
    this._pbasService
      .updateTestedPartyCharacterizationFeatures(
        this.data.testedParty.pba.pbaId,
        this.functionsPerformedRequest)
      .subscribe(() => {
        this.success();
        this.close();
      }
      );
  }

  private groupFunctionsPerformed(): void {
    const functionsPerformed = {};
    const functionsPerformedLength = this.functionsPerformed ? this.functionsPerformed.length : 0;
    for (let index = 0; index < functionsPerformedLength; index++) {
      const currentFunctionPerformed = this.functionsPerformed[index];
      if (currentFunctionPerformed && currentFunctionPerformed.functionPerformed && currentFunctionPerformed.functionPerformed.group !== null && currentFunctionPerformed.functionPerformed.group !== undefined) {
        const functionPerformedGroup = currentFunctionPerformed.functionPerformed.group;
        functionsPerformed[functionPerformedGroup] ? functionsPerformed[functionPerformedGroup].push(currentFunctionPerformed) : functionsPerformed[functionPerformedGroup] = [currentFunctionPerformed];
      }
    }
    this.functionsPerformed = Object.values(functionsPerformed);
  }

  private prepareFunctionsPerformedForRequest(): void {
    this.functionsPerformedRequest.characterizationFunctionsPerformed = [].concat(...this.functionsPerformed);
  }

}
